import React from 'react';
import cn from 'classnames';
import s from './HorizontalSeparator.scss';

interface Props {
  margins?: 'top' | 'bottom' | 'both' | 'none';
}

const HorizontalSeparator: React.FC<Props> = ({ margins = 'both' }) => (
  <hr className={cn(s['root'], s[`margins-${margins}`])} />
);
HorizontalSeparator.displayName = 'HorizontalSeparator';

export default HorizontalSeparator;
